import { ContextualSaveBar, Divider, InlineStack, Icon, Text, BlockStack, TextField, Button, InlineError, Modal, Layout, Tooltip } from '@shopify/polaris'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { DI, DIProps } from '../../../../../Core'
import { Switch, Tabs } from 'antd'
import useContextualSaveBar, { isAdminLoggedIn } from '../../../Panel/index';
import { RefreshMajor } from '@shopify/polaris-icons';
import { getLastSyncInformation } from '../../ConfigHelper';
import { RenderSkeletonEmailSetting } from '../../skeleton/skeleton';
import { useTranslation } from "react-i18next";
import { TickMinor, InfoMinor } from '@shopify/polaris-icons'
import { useMediaQuery } from '../../../../Utilities/useMediaQuery';


const Notifications = (props: DIProps) => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery('(max-width: 380px)');
    const [isValid, setIsValid] = useState(true);
    const [emailLoader, setEmailLoader] = useState<boolean>(false);
    const [verificationLoader, setVerificationLoader] = useState<boolean>(false);
    const [shouldTextFieldDisabled, setShouldTextFieldDisabled] = useState<boolean>(false);
    const [firstRender, setFirstRender] = useState<boolean>(false);
    const [alternateEmail, setAlternateEmail] = useState<string>('');
    const [savedAlternateEmail, setSavedAlternateEmail] = useState<string>('');
    const { showSaveBar, hideSaveBar } = useContextualSaveBar(props);
    const [selected, setSelected] = useState('email');
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
    const [emails, setEmails] = useState({
        email_on_failed_order: {
            checked: false,
            prev_checked: false,
            name: 'Failed order creation on Shopify'
        },
        email_on_failed_refund: {
            checked: false,
            prev_checked: false,
            name: 'Syncing failure of refunded orders'
        },
        email_on_failed_cancellation: {
            checked: false,
            prev_checked: false,
            name: 'Syncing failure of cancelled orders'
        },
        email_on_failed_shipment: {
            checked: false,
            prev_checked: false,
            name: "Syncing failure of shipping order"
        },
        send_mail_on_limit_exceed: {
            checked: false,
            prev_checked: false,
            name: 'Exceeding order plan limits'
        },
        send_mail_on_50_limit_exceed: {
            checked: false,
            prev_checked: false,
            name: 'Exceeding 50% order plan limits'
        },
        send_mail_on_90_limit_exceed: {
            checked: false,
            prev_checked: false,
            name: 'Exceeding 90% order plan limits'
        },
    })
    const [lastSync, setLastSync] = useState('');
    const [loading, setLoading] = useState({ get: false, save: false })
    const [noOfAttempts, setNoOfAttempts] = useState<number>(0);
    const [activateModal, setModalActive] = useState<boolean>(false);
    const [otpError, setOtpError] = useState<boolean>(false);
    const [otp, setOtp] = useState(new Array(5).fill(''));

    const inputRefs = useRef<any>([]);

    const getData = () => {
        props.di.POST('connector/config/getConfig', {
            "group_code": ["email"],
            target: { marketplace: 'amazon' },
            source: { marketplace: props?.redux?.current?.source?.marketplace ?? '', shopId: props?.redux?.current?.source?._id ?? '' }
        }).then(res => {
            // setLoading(a => ({ ...a, get: false }))
            if (res.success) {
                setEmails(a => {
                    a.send_mail_on_limit_exceed.checked = res.data[0].value?.send_mail_on_limit_exceed ?? true
                    a.send_mail_on_limit_exceed.prev_checked = res.data[0].value?.send_mail_on_limit_exceed ?? true
                    a.send_mail_on_50_limit_exceed.checked = res.data[0].value?.send_mail_on_50_limit_exceed ?? true
                    a.send_mail_on_50_limit_exceed.prev_checked = res.data[0].value?.send_mail_on_50_limit_exceed ?? true
                    a.send_mail_on_90_limit_exceed.checked = res.data[0].value?.send_mail_on_90_limit_exceed ?? true
                    a.send_mail_on_90_limit_exceed.prev_checked = res.data[0].value?.send_mail_on_90_limit_exceed ?? true
                    return { ...a }
                })
            } else props.error(t("Failed to get email settings"))
        })
        props.di.POST('connector/config/getConfig', {
            "group_code": ["email"],
            target: { marketplace: 'amazon', shopId: props?.redux?.current?.target?._id ?? '' },
            source: { marketplace: props?.redux?.current?.source?.marketplace ?? '', shopId: props?.redux?.current?.source?._id ?? '' }
        }).then(res => {
            setLoading(a => ({ ...a, get: false }))
            if (res.success) {
                setEmails(a => {
                    a.email_on_failed_order.checked = res.data[0].value?.email_on_failed_order ?? true
                    a.email_on_failed_order.prev_checked = res.data[0].value?.email_on_failed_order ?? true
                    a.email_on_failed_refund.checked = res.data[0].value?.email_on_failed_refund ?? true
                    a.email_on_failed_refund.prev_checked = res.data[0].value?.email_on_failed_refund ?? true
                    a.email_on_failed_cancellation.checked = res.data[0].value?.email_on_failed_cancellation ?? true
                    a.email_on_failed_cancellation.prev_checked = res.data[0].value?.email_on_failed_cancellation ?? true
                    a.email_on_failed_shipment.checked = res.data[0].value?.email_on_failed_shipment ?? false
                    a.email_on_failed_shipment.prev_checked = res.data[0].value?.email_on_failed_shipment ?? false
                    // a.send_mail_on_limit_exceed.checked = res.data[0].value?.send_mail_on_limit_exceed ?? true
                    // a.send_mail_on_limit_exceed.prev_checked = res.data[0].value?.send_mail_on_limit_exceed ?? true
                    // a.send_mail_on_50_limit_exceed.checked = res.data[0].value?.send_mail_on_50_limit_exceed ?? true
                    // a.send_mail_on_50_limit_exceed.prev_checked = res.data[0].value?.send_mail_on_50_limit_exceed ?? true
                    // a.send_mail_on_90_limit_exceed.checked = res.data[0].value?.send_mail_on_90_limit_exceed ?? true
                    // a.send_mail_on_90_limit_exceed.prev_checked = res.data[0].value?.send_mail_on_90_limit_exceed ?? true
                    return { ...a }
                })
                getLastOrderSyncDate()
            } else props.error(t("Failed to get email settings"))
        })
        props.di.GET('connector/email/getUserEmail').then((
            (res: any) => {
                if (res?.success && res?.data?.alternate_email) {
                    if (res?.data?.alternate_email == "") setFirstRender(true);
                    else setShouldTextFieldDisabled(true);
                    setAlternateEmail(res?.data?.alternate_email ?? '');
                    setSavedAlternateEmail(res?.data?.alternate_email ?? '');
                }
            }
        ))
    }

    const saveData = () => {
        setLoading(a => ({ ...a, save: true }))
        props.di.POST('connector/config/saveConfigForAll', {
            data: [
                {
                    data: JSON.parse(JSON.stringify({
                        send_mail_on_limit_exceed: emails.send_mail_on_limit_exceed.checked,
                        send_mail_on_50_limit_exceed: emails.send_mail_on_50_limit_exceed.checked,
                        send_mail_on_90_limit_exceed: emails.send_mail_on_90_limit_exceed.checked,
                    })),
                    apply: 'all',
                    group_code: "email"
                }
            ]
        }).then(res => {
            setLoading(a => ({ ...a, save: false }))
            if (res.success) {
                props.di.POST('connector/config/saveConfig', {
                    data: [
                        {
                            data: JSON.parse(JSON.stringify({
                                email_on_failed_order: emails.email_on_failed_order.checked,
                                email_on_failed_refund: emails.email_on_failed_refund.checked,
                                email_on_failed_cancellation: emails.email_on_failed_cancellation.checked,
                                email_on_failed_shipment: emails.email_on_failed_shipment.checked,
                                // send_mail_on_limit_exceed: emails.send_mail_on_limit_exceed.checked,
                                // send_mail_on_50_limit_exceed: emails.send_mail_on_50_limit_exceed.checked,
                                // send_mail_on_90_limit_exceed: emails.send_mail_on_90_limit_exceed.checked,
                            })),
                            group_code: "email"
                        }
                    ]
                }).then(res1 => {
                    setLoading(a => ({ ...a, save: false }))
                    if (res1.success) {
                        getData();
                        props.success(t('Email Settings saved successfully.'))
                    } else props.error(t("Failed to save email settings."))
                })
            } else props.error(t("Failed to save email settings"))
        })
    }

    const onChange = (key: 'email_on_failed_order' | 'email_on_failed_refund' | 'email_on_failed_cancellation' | 'email_on_failed_shipment' | 'send_mail_on_limit_exceed' | 'send_mail_on_50_limit_exceed' | 'send_mail_on_90_limit_exceed', checked: boolean) => {
        setEmails((a) => ({ ...a, [key]: { ...a[key], checked } }));
    }

    const handleDiscardBtn = () => {
        setLoading(a => ({ ...a, get: true }));
        getData()
    }

    const getLastOrderSyncDate = () => {
        let data = getLastSyncInformation(props, 'email');
        data.then((res: any) => {
            if (res?.error) props.error(t(res?.error) ?? '');
            else setLastSync(res?.date ?? '')
        })
    }

    useEffect(() => {
        setLoading(a => ({ ...a, get: true }))
        getData()
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 991);
        };
        window.addEventListener('resize', handleResize);
        return () => {// Clean up the event listener
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    const showContextualSaveBar = useMemo(() => {
        return emails.email_on_failed_order.checked !== emails.email_on_failed_order.prev_checked
            || emails.email_on_failed_refund.checked !== emails.email_on_failed_refund.prev_checked
            || emails.email_on_failed_cancellation.checked !== emails.email_on_failed_cancellation.prev_checked
            || emails.email_on_failed_shipment.checked !== emails.email_on_failed_shipment.prev_checked
            || emails.send_mail_on_limit_exceed.checked !== emails.send_mail_on_limit_exceed.prev_checked
            || emails.send_mail_on_limit_exceed.checked && (
                emails.send_mail_on_50_limit_exceed.checked !== emails.send_mail_on_50_limit_exceed.prev_checked
                || emails.send_mail_on_90_limit_exceed.checked !== emails.send_mail_on_90_limit_exceed.prev_checked
            )
    }, [emails])

    //Contextual Save Bar of App Bridge
    if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) {
        let savebar_options: any = {
            loading: loading.get || loading.save,
        };
        if (showContextualSaveBar) {
            showSaveBar(handleDiscardBtn, saveData, { ...savebar_options });
        } else hideSaveBar();
    }

    const getBtnName = () => {
        let name: "Add" | "Edit" | "Verify" = "Add";
        if (firstRender) name = "Add";
        else if (!firstRender && !shouldTextFieldDisabled) name = "Verify";
        else name = "Edit";
        return name;
    }

    const verifyEmailAddress = () => {
        setEmailLoader(true);
        props.di.POST("user/otpMail", {
            email: alternateEmail.trim(),
            templateSource: "amazon",
            subject: "OTP - Cedcommerce Amazon Channel"
        }).then((res: any) => {
            if (res?.success) {
                setModalActive(true);
                setNoOfAttempts(res?.no_of_attempts_left ?? 0)
                props.success(t(res?.message) ?? t("OTP has been sent successfully to your email address"));
            }
            else {
                props.error(t(res?.message) ?? t("Oops! some error occured while sending OTP."))
            }
            setEmailLoader(false);
        })
    }

    const saveAlternateEmail = () => {
        if (isValid) {
            let btnName = getBtnName();
            if (btnName == "Edit") {
                setShouldTextFieldDisabled(false);
                // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                // setIsValid(emailRegex.test(alternateEmail.trim()));
                // setVerifyMessage("Verify the email id")
            }
            else if (btnName == "Add" || "Verify") {
                verifyEmailAddress();
            }
        }
        else {
            props.error(t("Invalid email address"))
        }
    }

    const tabs = [
        {
            key: 'email',
            id: 'email',
            label: t('Email'),
            disabled: loading.get || loading.save,
            children: <>
                {loading.get ? RenderSkeletonEmailSetting() :
                    <BlockStack gap="500">
                        <BlockStack gap="300">
                            <BlockStack gap="200">
                                <Text as='h2' variant='headingMd' fontWeight='semibold'>{t("Email Settings")}</Text>
                                <Text as='p' tone='subdued'>{t("Confirm settings for email notifications. We follow a no spam policy.")}</Text>
                            </BlockStack>
                            <InlineStack gap={'300'}>
                                <div className='Custom-Stack-Item--fill' >
                                    <BlockStack gap={"100"}>
                                        <div style={{ minWidth: "260px" }}>
                                            <TextField error={!isValid} disabled={shouldTextFieldDisabled || emailLoader} autoComplete='off' label={t('Alternate email id')} value={alternateEmail} onChange={(e) => {
                                                setAlternateEmail(e);
                                                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                                setIsValid(emailRegex.test(e.trim()));
                                            }} placeholder={t('Eg. john@gmail.com')} />
                                        </div>
                                        {alternateEmail != savedAlternateEmail ? isValid ?
                                            <InlineStack gap={"100"} blockAlign='center'>
                                                <span><Icon tone='warning' source={InfoMinor} /></span>
                                                <Text as='p' tone='caution' variant='bodyMd'>{t("Verify the email address")}</Text>
                                            </InlineStack> : null : alternateEmail != "" ?
                                            <InlineStack gap={"100"}>
                                                <span><Icon tone='success' source={TickMinor} /></span>
                                                <Text as='p' tone='success' variant='bodyMd'>{t("Verified")}</Text>
                                            </InlineStack> : null}
                                        {!isValid && <InlineError message={t("Invalid email address")} fieldID="emailError" />}
                                    </BlockStack>
                                </div>
                                <div style={{ marginTop: isMobile ? '0' : '25px' }}>
                                    {savedAlternateEmail == alternateEmail && getBtnName() == "Verify" ?
                                        <Tooltip
                                            content={savedAlternateEmail == alternateEmail && getBtnName() == "Verify" ? t("New and saved emails are same") : null}>
                                            <Button
                                                loading={emailLoader}
                                                size={'large'}
                                                variant={getBtnName() == "Verify" ? "primary" : undefined}
                                                onClick={() => saveAlternateEmail()}
                                                disabled={savedAlternateEmail == alternateEmail && getBtnName() == "Verify"}>
                                                {t(getBtnName())}
                                            </Button>
                                        </Tooltip> :
                                        <Button
                                            loading={emailLoader}
                                            size={'large'}
                                            variant={getBtnName() == "Verify" ? "primary" : undefined}
                                            onClick={() => saveAlternateEmail()}
                                            disabled={savedAlternateEmail == alternateEmail && getBtnName() == "Verify"}>
                                            {t(getBtnName())}
                                        </Button>}
                                </div>
                            </InlineStack>
                        </BlockStack>
                        <Divider />
                        <BlockStack gap="400">
                            <BlockStack gap="500">
                                <InlineStack gap="200" wrap={false}>
                                    <Switch
                                        className='switcherBtn'
                                        size='small'
                                        id='send_mail_on_limit_exceed'
                                        disabled={loading.get || loading.save}
                                        checked={emails.send_mail_on_limit_exceed.checked}
                                        onChange={(checked) => { onChange('send_mail_on_limit_exceed', checked) }}
                                    />
                                    <BlockStack gap="300">
                                        <BlockStack gap="100">
                                            <div className='Custom__Line--Height'>
                                                <Text variant="headingSm" as="h6" id='order_Text_ReceiveEmailAlertsForFailedOrders'>
                                                    {t("Alert for exceeding order limit")}
                                                </Text>
                                            </div>
                                            <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_ReceiveEmailAlertsForFailedOrdersDescription'>
                                                {t("Get a mail on your registered email when the order limit is exceeded")}
                                            </Text>
                                            <Text as='p' tone='success'><Text as='span' fontWeight='semibold'>{t("Note")}:</Text> {t("This is a global setting and will be applied to all connected Amazon a/c.")}
                                            </Text>
                                        </BlockStack>
                                        <InlineStack gap="200" wrap={false}>
                                            <Switch
                                                className='switcherBtn'
                                                size='small'
                                                id='send_mail_on_50_limit_exceed'
                                                disabled={loading.get || loading.save || !emails.send_mail_on_limit_exceed.checked}
                                                checked={emails.send_mail_on_limit_exceed.checked && emails.send_mail_on_50_limit_exceed.checked}
                                                onChange={(checked) => { onChange('send_mail_on_50_limit_exceed', checked) }}
                                            />
                                            <Text as='p'>{t("On exceeding 50%")}</Text>
                                        </InlineStack>
                                        <InlineStack gap="200" wrap={false}>

                                            <Switch
                                                className='switcherBtn'
                                                size='small'
                                                id='send_mail_on_90_limit_exceed'
                                                disabled={loading.get || loading.save || !emails.send_mail_on_limit_exceed.checked}
                                                checked={emails.send_mail_on_limit_exceed.checked && emails.send_mail_on_90_limit_exceed.checked}
                                                onChange={(checked) => { onChange('send_mail_on_90_limit_exceed', checked) }}
                                            />
                                            <Text as='p'>{t("On exceeding 90%")}</Text>
                                        </InlineStack>
                                    </BlockStack>
                                </InlineStack>
                                <InlineStack gap="200" wrap={false}>

                                    <Switch
                                        className='switcherBtn'
                                        size='small'
                                        id='email_on_failed_order'
                                        disabled={loading.get || loading.save}
                                        checked={emails.email_on_failed_order.checked}
                                        onChange={(checked) => { onChange('email_on_failed_order', checked) }}
                                    />
                                    <BlockStack gap="100">
                                        <div className='Custom__Line--Height'>
                                            <Text variant="headingSm" as="h6" id='order_Text_ReceiveEmailAlertsForFailedOrders'>
                                                {t("Failed order sync with Shopify")}
                                            </Text>
                                        </div>
                                        <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_ReceiveEmailAlertsForFailedOrdersDescription'>
                                            {t("Get a mail on your registered email when Amazon orders fail to sync with Shopify.")}
                                        </Text>
                                    </BlockStack>
                                </InlineStack>
                                <InlineStack gap="200" wrap={false}>

                                    <Switch
                                        className='switcherBtn'
                                        size='small'
                                        id='email_on_failed_shipment'
                                        disabled={loading.get || loading.save}
                                        checked={emails.email_on_failed_shipment.checked}
                                        onChange={(checked) => { onChange('email_on_failed_shipment', checked) }}
                                    />
                                    <BlockStack gap="100">
                                        <div className='Custom__Line--Height'>
                                            <Text variant="headingSm" as="h6" id='order_Text_ReceiveEmailAlertsForFailedOrders'>
                                                {t("Failed shipment order sync")}
                                            </Text>
                                        </div>
                                        <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_ReceiveEmailAlertsForFailedOrdersDescription'>
                                            {t("Get a mail on your registered email when shipment orders fail to sync with Amazon.")}
                                        </Text>
                                    </BlockStack>
                                </InlineStack>
                                <InlineStack gap="200" wrap={false}>

                                    <Switch
                                        className='switcherBtn'
                                        size='small'
                                        id='email_on_failed_refund'
                                        disabled={loading.get || loading.save}
                                        checked={emails.email_on_failed_refund.checked}
                                        onChange={(checked) => { onChange('email_on_failed_refund', checked) }}
                                    />
                                    <BlockStack gap="100">
                                        <div className='Custom__Line--Height'>
                                            <Text variant="headingSm" as="h6" id='order_Text_ReceiveEmailAlertsForFailedOrders'>
                                                {t("Failed refund order sync")}
                                            </Text>
                                        </div>
                                        <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_ReceiveEmailAlertsForFailedOrdersDescription'>
                                            {t("Get a mail on your registered email when refund orders fail to sync with Amazon.")}
                                        </Text>
                                    </BlockStack>
                                </InlineStack>
                                <InlineStack gap="200" wrap={false}>
                                    <Switch
                                        className='switcherBtn'
                                        size='small'
                                        id='email_on_failed_cancellation'
                                        disabled={loading.get || loading.save}
                                        checked={emails.email_on_failed_cancellation.checked}
                                        onChange={(checked) => { onChange('email_on_failed_cancellation', checked) }}
                                    />
                                    <BlockStack gap="100">
                                        <div className='Custom__Line--Height'>
                                            <Text variant="headingSm" as="h6" id='order_Text_ReceiveEmailAlertsForFailedOrders'>
                                                {t("Failed canceled order sync")}
                                            </Text>
                                        </div>
                                        <Text as="p" fontWeight="regular" tone='subdued' id='order_Text_ReceiveEmailAlertsForFailedOrdersDescription'>
                                            {t("Get a mail on your registered email when canceled orders fail to sync with Shopify.")}
                                        </Text>
                                    </BlockStack>
                                </InlineStack>

                            </BlockStack>
                        </BlockStack>
                        {lastSync && <>
                            <Divider />
                            <InlineStack blockAlign='center' align='space-between' gap="200">
                                <div className='Custom__Sync--Update'>
                                    <InlineStack gap="200" wrap={false}>
                                        <div>
                                            <Icon source={RefreshMajor} tone="base" />
                                        </div>
                                        <Text variant="headingSm" as="h6" tone='subdued'>
                                            {t("Last updated")}: {lastSync}
                                        </Text>
                                    </InlineStack>
                                </div>
                            </InlineStack>
                        </>}
                    </BlockStack>}
            </>,
        },
    ];

    const handleModalChange = useCallback(() => {
        setOtpError(false);
        setModalActive(!activateModal);
        setNoOfAttempts(0);
        setOtp(new Array(5).fill(''))
    }, [activateModal]);

    const verifyOTP = () => {
        // If all fields are filled, call the verify function
        if (otp.every((digit) => digit !== '')) {
            setVerificationLoader(true);
            props.di.GET("connector/email/updateUserEmail", {
                alternate_email: alternateEmail.trim(),
                otp: otp.join(''),
            }).then((res: any) => {
                if (res?.success) {
                    props.success(res?.message ?? "Alternate email updated successfully!")
                    setModalActive(false);
                    setNoOfAttempts(0);
                    setShouldTextFieldDisabled(true)
                    setOtp(new Array(5).fill(''));
                    setSavedAlternateEmail(alternateEmail);
                    // props.success(t(res?.message) ?? t("Alternate email id saved successfully"));
                }
                else {
                    setOtpError(true);
                    props.error(t(res?.message) ?? t("Oops! some error occured while verifying email id."))
                }
                setVerificationLoader(false);
            });
        }
    }

    const handleChange = (element: any, index: number) => {
        if (isNaN(element.value)) return;

        const newOtp = [...otp];
        newOtp[index] = element.value;
        setOtp(newOtp);

        // Move focus to the next input field if a digit is entered
        if (element.value && index < 4) {
            inputRefs.current[index + 1].focus();
        }
    };

    return (
        <div className='Custom__Vertical--Tab'>
            <Tabs
                tabPosition={isSmallScreen ? "top" : "left"}
                onChange={(e) => { setSelected(e); props.history(e) }}
                items={tabs}
                activeKey={selected}
                destroyInactiveTabPane
            />
            {
                showContextualSaveBar &&
                (process.env.REACT_APP_PROD === "0" ||
                    isAdminLoggedIn()) && (
                    <ContextualSaveBar
                        message={t("Unsaved changes")}
                        saveAction={{
                            onAction: () => saveData(),
                            loading: loading.save,
                            disabled: false,
                        }}
                        discardAction={{
                            onAction: () => { handleDiscardBtn() },
                            loading: loading.save,
                            disabled: false,
                        }}
                    />
                )
            }

            <Modal
                open={activateModal}
                onClose={handleModalChange}
                title={t("Verify your email")}
                primaryAction={{
                    content: t("Confirm OTP"),
                    onAction: verifyOTP,
                    loading: verificationLoader,
                    disabled: otp.some((digit: string) => digit == "")
                }}
                // secondaryActions={[
                //     {
                //         content: "Resend OTP",
                //         onAction: verifyEmailAddress,
                //         loading: verificationLoader || emailLoader
                //     },
                // ]}
                secondaryActions={[
                    {
                        content: t("Cancel"),
                        onAction: handleModalChange,
                    },
                ]}
            >
                <Modal.Section>
                    <Layout>
                        <Layout.Section>
                            <Text as="p" variant='bodyMd'>
                                {t(`Please enter the 5-digit OTP sent to your email address`)}
                            </Text>
                            <Text as='p' variant='bodyMd' fontWeight='medium' tone='subdued'>
                                {alternateEmail}
                            </Text>
                        </Layout.Section>

                        <Layout.Section>
                            <BlockStack gap={"400"}>
                                <BlockStack gap={"300"}>
                                    <Text as="p" alignment="center" variant='bodyMd' fontWeight='medium'>
                                        {t("OTP is valid for 15:00 mins")}
                                    </Text>
                                    <InlineStack align='center' gap={"300"}>
                                        {otp.map((data, index) => (
                                            <input
                                                className={`custom-otp__inputBox ${otpError ? "custom-otp__inputBox--error" : ""}`}
                                                key={index}
                                                type="text"
                                                maxLength={1}
                                                value={data}
                                                onChange={(e) => handleChange(e.target, index)}
                                                ref={(el) => (inputRefs.current[index] = el)}
                                            />
                                        ))}
                                    </InlineStack>
                                    {otpError && <InlineStack align='center'>
                                        <Text as='p' variant='bodyMd' tone='critical'>Please enter valid OTP</Text>
                                    </InlineStack>}
                                </BlockStack>
                                {(otpError || !!noOfAttempts) && <Divider />}
                                <BlockStack gap={"200"} inlineAlign='center'>
                                    <Tooltip content={t("Click here to resend the OTP")}>
                                        <Button variant='plain' loading={verificationLoader || emailLoader} onClick={verifyEmailAddress}>{t("Resend OTP")}</Button>
                                    </Tooltip>
                                    {!!noOfAttempts && <Text as="p" tone='subdued' variant='bodyMd'>
                                        {`${t("You have")} ${noOfAttempts} ${t("attempts left to resend the OTP")}`}
                                    </Text>}
                                </BlockStack>
                            </BlockStack>
                        </Layout.Section>
                    </Layout>
                </Modal.Section>
            </Modal>

        </div>
    )
}

export default DI(Notifications)